import { Button, Form, Input, Space } from "antd";
import { useEffect } from "react";
import CustomModal from "../../../../components/ui/CustomModal";
import Loader from "../../../../components/ui/Loader";
import {
  useCreateWalletTagMutation,
  useGetSingleWalletTagQuery,
  useUpdateWalletTagMutation,
} from "../../../../features/portal/companyOnboard/companyOnboardApi";
import useError from "../../../../hooks/useError";
import { toast } from "../../../../lib/toast";

type Props = {
  open: boolean;
  handleClose: () => void;
  data?: any;
  type?: "ADD" | "UPDATE";
};

export default function AddWalletTagModal({
  open,
  handleClose,
  data,
  type,
}: Props) {
  const [form] = Form.useForm();

  const [
    createWalletTag,
    {
      isError: createWalletTagIsError,
      error: createWalletTagError,
      isLoading: createWalletTagIsLoading,
      isSuccess: createWalletTagIsSuccess,
    },
  ] = useCreateWalletTagMutation();

  const {
    data: getSingleWalletTagData,
    isError: getSingleWalletTagIsError,
    error: getSingleWalletTagError,
    isLoading: getSingleWalletTagIsLoading,
  } = useGetSingleWalletTagQuery(data, {
    skip: !data,
  });

  const [
    updateWalletTag,
    {
      isError: updateWalletTagIsError,
      error: updateWalletTagError,
      isLoading: updateWalletTagIsLoading,
      isSuccess: updateWalletTagIsSuccess,
    },
  ] = useUpdateWalletTagMutation();

  useError(
    createWalletTagIsError,
    createWalletTagError,
    "Wallet tag create fail"
  );
  useError(
    getSingleWalletTagIsError,
    getSingleWalletTagError,
    "Get single wallet tag fail"
  );
  useError(
    updateWalletTagIsError,
    updateWalletTagError,
    "Wallet tag update fail"
  );

  const onFinish = (values: any) => {
    const newData = {
      ...values,
    };

    if (type === "UPDATE" && data) {
      updateWalletTag({ data: newData, id: data });
    } else {
      createWalletTag(newData);
    }
  };

  useEffect(() => {
    if (createWalletTagIsSuccess) {
      toast("success", "Tag created successfully!");
      form.resetFields();
      handleClose();
    }
  }, [createWalletTagIsSuccess, form, handleClose]);

  useEffect(() => {
    if (updateWalletTagIsSuccess) {
      toast("success", "Tag updated successfully!");
      form.resetFields();
      handleClose();
    }
  }, [updateWalletTagIsSuccess, form, handleClose]);

  useEffect(() => {
    if (type === "UPDATE" && data) {
      form.setFieldsValue({
        name: getSingleWalletTagData?.data?.name,
      });
    }
  }, [data, form, type, getSingleWalletTagData?.data?.name]);

  return (
    <>
      <CustomModal
        title={type === "UPDATE" && data ? "Edit Tag" : "Add New Tag"}
        open={open}
        handleClose={handleClose}
        footer={null}
      >
        {getSingleWalletTagIsLoading ? (
          <Loader />
        ) : (
          <Form
            name="form_item_path"
            className="custom-form"
            layout="vertical"
            onFinish={onFinish}
            requiredMark="optional"
            size="large"
            form={form}
          >
            <Form.Item
              label="Tag Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please enter a tag name",
                },
              ]}
            >
              <Input placeholder="Tag Name" allowClear />
            </Form.Item>

            <Space className="w-full mt-2" size={12}>
              <Button
                className="normal-dark-button modal-button !h-[40px]"
                onClick={handleClose}
                size="middle"
              >
                Cancel
              </Button>

              <Button
                className="modal-button !h-[40px]"
                type="primary"
                htmlType="submit"
                size="middle"
                loading={createWalletTagIsLoading || updateWalletTagIsLoading}
              >
                {type === "UPDATE" && data ? "Update" : "Add"}
              </Button>
            </Space>
          </Form>
        )}
      </CustomModal>
    </>
  );
}
